import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function OrganizationTemplate({
  title = "",
  classes,
  placement = "right"
}) {
  return (
    // <OverlayTrigger
    //   defaultShow={false}
    //   placement={placement}
    //   overlay={<Tooltip className={`tooltip-organisation`}>{title}</Tooltip>}
    // >
    <span className={classes}>
      {/* {title && title.length > 31 ? `${title.substr(0, 31)}...` : title} */}
      {title}
    </span>
    // </OverlayTrigger>
  );
}
